import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { menuItemStyles, MenuItemProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-menu-item',
  templateUrl: './menu-item.component.html',
})
export class MenuItemComponent {
  @ViewChild('itemRef') itemRef: ElementRef;
  @ViewChild('containerRef') containerRef: ElementRef;

  @Input() title: string;
  @Input() description: string;
  @Input() icon: string;
  @Input() onToggle: MenuItemProps['onToggle'];
  @Input() css: MenuItemProps['css'];

  _isChecked = false;

  @Input() get isChecked() {
    return this._isChecked;
  }

  set isChecked(value: boolean) {
    this._isChecked = value;
  }

  _isCheckable = false;

  @Input() get isCheckable() {
    return this._isCheckable;
  }

  set isCheckable(value: boolean) {
    this._isCheckable = value;
  }

  /**
   * Estilos del select
   */
  public get menuItem(): string[] {
    return [
      menuItemStyles({
        isChecked: this.isChecked,
        css: this.css,
      }).className,
    ];
  }

  toggleChecked() {
    // If a function is provided, ignore normal behavior
    if (this.onToggle) {
      this.onToggle()
    } else {
      this.isChecked = !this.isChecked;
    }
  }
}
